import './App.css';
import { OpointAuthProvider } from '@opoint/authjs-react';
import DailyTasks from './components/DailyTasks';
import logo from './assets/daily-tasks.png';

function App() {
    return (
        <OpointAuthProvider
            API_URL="https://auth.opoint.com"
            callback={"https:∕∕" + window.location.host + "/callback"}
        >
            <div className="App">
                <div className="header">
                    <div className="logo">
                        <img 
                            height="120px" 
                            src={logo} 
                            alt="logo" 
                        />
                    </div>
                    <div className="tools-link">
                        <a href="/">
                            back to tools
                        </a>
                    </div>
                </div>
                <DailyTasks />
            </div>
        </OpointAuthProvider>
    );
}

export default App;
